export enum RelationshipType {
    Spouse = 1,
    Parent = 2,
    Sibling = 3,
    Child = 4,
    Other = 5,
}
